export default "__VITE_ASSET__55mo2p_9__"